import React, { useState } from "react";
import { Button, Grid, Card, Box, Chip, Divider } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import apiRequest from "../../../../apiRequest";
import ImagePreview from "../../../../components/ImagePreview/ImagePreview";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog";

const PartnerProfileSidebar = ({
    partnerInfo,
    loading,
    handleTaxAction,
    setSelectedId,
    setActionType,
    setReasonModalOpen,
}) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmData, setConfirmData] = useState(null);
    console.log("confirmData", confirmData)

    const partnerProfileDetails = [
        {
            label: "Date of Birth",
            value: partnerInfo?.dob ? new Date(partnerInfo?.dob).toLocaleDateString() : "-",
        },
        {
            label: "Mobile",
            value: partnerInfo?.contact || "-",
        },
        {
            label: "Email",
            value: partnerInfo?.email || "-",
        },
        {
            label: "Status",
            value: partnerInfo?.status || "-",
        },
    ];

    const driverProfileDetails = [
        {
            label: "Driver Contact",
            value: partnerInfo?.driver?.contact_number || "-",
            hideIfMatches: partnerInfo?.contact,
        },
        {
            label: "Licence No",
            value: partnerInfo?.driver?.driving_licence_no || "-",
            hide: !!partnerInfo?.driver?.driving_licence_no,
        },
        {
            label: "Licence Expiry",
            value: partnerInfo?.driver?.licence_expiry_date
                ? new Date(
                    partnerInfo.driver.licence_expiry_date
                ).toLocaleDateString()
                : "-",
            hide: !!partnerInfo?.driver?.licence_expiry_date,
        },
        {
            label: "Business Account",
            value: partnerInfo?.driver?.is_business ? "Yes" : "No",
        },
    ];


    const InfoRow = ({ label, value }) => (
        <MDBox>
            <MDTypography
                variant="caption"
                color="text.secondary"
                sx={{ fontWeight: 600, letterSpacing: 0.5 }}
            >
                {label}
            </MDTypography>
            <MDTypography variant="body1" fontWeight={500}>
                {value || "-"}
            </MDTypography>
        </MDBox>
    );

    // console.log("partnerInfo", partnerInfo)
    return (
        <>
            <Grid container spacing={3}>
                {/* LEFT CARD */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, height: "100%" }}>
                        <MDTypography
                            variant="caption"
                            color="text.secondary"
                            textTransform="uppercase"
                            fontWeight={600}
                        >
                            Partner Profile
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight={600} mb={1}>
                            {partnerInfo?.full_name || "-"}
                        </MDTypography>
                        <Divider sx={{ mb: 2 }} />

                        <Grid container spacing={2}>
                            {partnerProfileDetails
                                .filter(detail => detail.label.toLowerCase() !== "status")
                                .map((detail) => (
                                    <Grid item xs={12} sm={6} key={detail.label}>
                                        <InfoRow {...detail} />
                                    </Grid>
                                ))}
                        </Grid>


                        {partnerInfo?.profile && (
                            <MDBox mt={3}>
                                <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    mb={1}
                                >
                                    Profile photo
                                </MDTypography>
                                <Box
                                    component="img"
                                    src={`${apiRequest.BASE_URL}/${partnerInfo?.profile}`}
                                    onClick={() => {
                                        setPreviewImage(
                                            `${apiRequest.BASE_URL}/${partnerInfo?.profile}`
                                        );
                                        setPreviewOpen(true);
                                    }}
                                    sx={{
                                        width: 120,
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 3,
                                        border: "1px solid #e5e7eb",
                                        boxShadow: "0 4px 12px rgba(15,23,42,0.08)",
                                        cursor: "pointer",
                                    }}
                                />
                            </MDBox>
                        )}
                    </Card>
                </Grid>

                {/* RIGHT CARD */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, height: "100%" }}>
                        <MDTypography
                            variant="caption"
                            color="text.secondary"
                            textTransform="uppercase"
                            fontWeight={600}
                        >
                            Driver & Account
                        </MDTypography>
                        <MDBox display="flex" alignItems="center" gap={1} mb={1.5}>
                            <MDTypography variant="h6" fontWeight={600} height={25}>
                                {/* {partnerInfo?.driver?.full_name || "-"} */}
                            </MDTypography>

                        </MDBox>
                        <Divider sx={{ mb: 2 }} />

                        <Grid container spacing={2}>
                            {driverProfileDetails
                                .filter((detail) => !detail.hide)
                                .map((detail) => (
                                    <Grid item xs={12} sm={6} key={detail.label}>
                                        <InfoRow {...detail} />
                                    </Grid>
                                ))}
                        </Grid>


                        {partnerInfo?.driver?.status !== "approved" && (
                            <MDBox mt={2}>
                                <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    fontWeight={600}
                                >
                                    Status notes
                                </MDTypography>

                                <MDTypography variant="body2">
                                    {partnerInfo?.driver?.reason_for_rejection || "No rejection notes"}
                                </MDTypography>
                            </MDBox>
                        )}



                        {partnerInfo?.driver?.driving_licence_photo && (
                            <MDBox mt={3}>
                                <MDTypography
                                    variant="caption"
                                    color="text.secondary"
                                    display="block"
                                    mb={1}
                                >
                                    Licence document
                                </MDTypography>
                                <Box
                                    component="img"
                                    src={`${apiRequest.BASE_URL}/${partnerInfo?.driver?.driving_licence_photo}`}
                                    onClick={() => {
                                        setPreviewImage(
                                            `${apiRequest.BASE_URL}/${partnerInfo?.driver?.driving_licence_photo}`
                                        );
                                        setPreviewOpen(true);
                                    }}
                                    sx={{
                                        width: 120,
                                        height: 120,
                                        objectFit: "cover",
                                        borderRadius: 3,
                                        border: "1px solid #e5e7eb",
                                        boxShadow: "0 4px 12px rgba(15,23,42,0.08)",
                                        cursor: "pointer",
                                    }}
                                />
                            </MDBox>
                        )}
                    </Card>
                </Grid>
            </Grid>



            <MDBox mt={3} display="flex" gap={1.5} justifyContent="flex-end" flexWrap="wrap">

                <Button
                    variant="outlined"
                    disabled={loading || partnerInfo?.driver?.status === "approved"}
                    onClick={() => {
                        setConfirmData({
                            id: partnerInfo?.driver?.id,
                            action: "approved",
                        });
                        setConfirmOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#2e7d32",
                        borderColor: "#2e7d32",
                    }}
                >
                    Approve
                </Button>


                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(partnerInfo?.driver?.id);
                        setActionType("rejected");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#d32f2f",
                        borderColor: "#d32f2f",
                        "&:hover": {
                            bgcolor: "#f5f5f5",
                            borderColor: "#b71c1c",
                        },
                    }}
                >
                    Reject
                </Button>

                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(partnerInfo?.id);
                        setActionType("request_info");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#ed6c02",
                        borderColor: "#ed6c02",
                        "&:hover": {
                            bgcolor: "#f5f5f5",
                            borderColor: "#e65100",
                        },
                    }}
                >
                    Request Info
                </Button>
            </MDBox>

            <ImagePreview
                open={previewOpen}
                imageSrc={previewImage}
                onClose={() => setPreviewOpen(false)}
            />
            <ConfirmDialog
                open={confirmOpen}
                title="Approve Driver"
                description="Are you sure you want to approve this driver?"
                confirmText="Yes, Approve"
                confirmColor="success"
                loading={loading}
                onClose={() => setConfirmOpen(false)}
                onConfirm={async () => {
                    await handleTaxAction(confirmData?.id, confirmData?.action, "approved by admin");
                    setConfirmOpen(false);
                }}
            />


        </>
    );
};

export default PartnerProfileSidebar;
